/** Mises en forme partagées. Les chiffres se lisent en colonnes alignées. */

const NOMBRE = new Intl.NumberFormat("fr-FR");

const MONTANT = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formaterNombre(valeur: number | null | undefined): string {
  if (valeur == null) return "—";
  return NOMBRE.format(valeur);
}

/**
 * Montant à deux décimales, sans devise.
 *
 * La devise est portée par la colonne ou l'en-tête, jamais répétée sur chaque
 * ligne : dans une balance, elle est la même partout et n'ajoute que du bruit.
 */
export function formaterMontant(valeur: number | null | undefined): string {
  if (valeur == null) return "—";
  return MONTANT.format(valeur);
}

export function formaterDate(iso: string | null | undefined): string {
  if (iso == null) return "—";
  return new Date(iso).toLocaleDateString("fr-FR");
}
